import React from "react";
import PageHeader from "./PageHeader.jsx";

export default function About() {
  return (
    <div className="page about-page">
      <PageHeader
        title="About Kinder"
        description="Data sources and contact information"
      />

      <p style={{ textAlign: 'center' }}>
        Copyright © Dan Stoyell 2025
      </p>
      <p style={{ textAlign: 'center' }}>
        Contact: the most common name my nickname refers to plus my last name at gmail.com
      </p>

      <h3>Dataset References</h3>
      <table className="dataset-table">
        <thead>
          <tr>
            <th>Dataset</th>
            <th>Author</th>
            <th>Year</th>
            <th>Source</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>SSA Popular Baby Names</td>
            <td>Social Security Administration</td>
            <td>1880–2024</td>
            <td>
              <a href="https://www.ssa.gov/oact/babynames/limits.html">Link</a>
            </td>
          </tr>
          <tr>
            <td>Name Clusters</td>
            <td>Daniel Caspi</td>
            <td>2021</td>
            <td>
              <a href="https://github.com/dxdc/babynames">GitHub</a>
            </td>
          </tr>
          <tr>
            <td>Name Demographics</td>
            <td>Konstantinos Tzioumis</td>
            <td>2018</td>
            <td>
              <a href="https://doi.org/10.7910/DVN/TYJKEZ/MPMHFE">Harvard Dataverse</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
